import { sfProduct } from '@/api/product';
import Vue from "vue";
import Component from "vue-class-component";
import REQ_URL from '@/consts/req-url';
import { Watch } from 'vue-property-decorator';
import { getCategoryTrail, getCategoryTree, getCategoryTrailById } from '@/api/categories';

interface CategoryPathItem {
    id: string,
    name: string
}

@Component({
})
export default class Breadcrumbs extends Vue {
    items: { text: string, disabled: boolean, href: string }[] = []
    @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
        this.calcNav()
    }
    async isProductPage() {
        const path = this.$route.path
        const [categoryPath] = await Promise.all([
            this.loadingCategoryPath(this.$route.params.id),
            getCategoryTree()
        ])
        if (path !== this.$route.path) return
        categoryPath.forEach((item, ind) => {
            const trail = getCategoryTrailById(item.id)
            this.items.push({
                text: item.name,
                disabled: false,
                // Tree not loaded or category unknown to it: rebuild the route from names
                href: trail ? trail[trail.length - 1].href
                    : '/categories/' + categoryPath.slice(0, ind + 1).map((step) => encodeURIComponent(step.name)).join('/')
            })
        })
    }
    isContactPage() {
        this.items.push({
            text: 'Контакты',
            disabled: true,
            href: '/contacts'
        })
    }
    async isCatPage() {
        const path = this.$route.path
        const segments = this.$route.params.cat.split('/')
        const trail = await getCategoryTrail(segments)
        if (path !== this.$route.path) return
        if (!trail) {
            this.items.push({
                text: segments[segments.length - 1],
                disabled: true,
                href: path
            })
            return
        }
        trail.forEach((node, ind) => {
            this.items.push({
                text: node.name,
                disabled: ind === trail.length - 1,
                href: node.href
            })
        })
    }
    async loadingCategoryPath(id: string): Promise<CategoryPathItem[]> {
        try {
            let data = await this.$fetch<sfProduct & { categoryPath?: CategoryPathItem[] }>(REQ_URL.GET_PRODUCT + `?id=${id}`)
            if (data.body) {
                if (data.body.categoryPath) return data.body.categoryPath
                // Offline the SW answers from IndexedDB, without categoryPath
                return await this.offlineCategoryPath(id)
            } else throw new Error('Некорректные данные запроса')
        } catch (error) {
            console.log(error)
            return []
        }
    }
    // The article's category from the category → articles map the SW keeps cached
    async offlineCategoryPath(article: string): Promise<CategoryPathItem[]> {
        const [res] = await Promise.all([fetch(REQ_URL.GET_CATEGORY_ARTICLES), getCategoryTree()])
        const articles: { [id: string]: string[] } = (await res.json()).body || {}
        const id = Object.keys(articles).find((key) => articles[key].includes(article))
        const trail = id ? getCategoryTrailById(id) : undefined
        return trail ? trail.map((node) => ({ id: node.id, name: node.name })) : []
    }
    calcNav() {
        this.items = [{
            text: 'Главная',
            disabled: false,
            href: '/'
        }]
        switch (this.$route.name) {
            case 'product':
                this.isProductPage()
                break;
            case 'Contacts':
                this.isContactPage()
                break;
            case 'categories':
                this.isCatPage()
                break;
            default:
                break;
        }
    }
}
